var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartialProtection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Low (yellow), SIze=16, Type=Fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44531 0C4.02703 0 0.445312 3.58172 0.445312 8C0.445312 12.4183 4.02703 16 8.44531 16C12.8636 16 16.4453 12.4183 16.4453 8C16.4453 5.87827 15.6025 3.84344 14.1022 2.34315C12.6019 0.842855 10.567 0 8.44531 0ZM8.44531 12C8.00348 12 7.64531 11.6418 7.64531 11.2C7.64531 10.7582 8.00348 10.4 8.44531 10.4C8.88714 10.4 9.24531 10.7582 9.24531 11.2C9.24531 11.6418 8.88714 12 8.44531 12ZM8.44531 9.6C8.88714 9.6 9.24531 9.24183 9.24531 8.8V4.8C9.24531 4.35817 8.88714 4 8.44531 4C8.00348 4 7.64531 4.35817 7.64531 4.8V8.8C7.64531 9.24183 8.00348 9.6 8.44531 9.6Z",
    fill: "#FFD465"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialProtection);
export default __webpack_public_path__ + "static/media/partial_protection.b93f666f025489662126651543d39774.svg";
export { ForwardRef as ReactComponent };